import { Injectable } from '@angular/core';
import { ServiceRequestService } from 'src/app/service/service-request.service';

@Injectable({
  providedIn: 'root',
})
export class ReusableFilterService {
  constructor(private _serviceRequestService: ServiceRequestService) {}

  callApiIfNoDataFound(event: string, memberId: string): Promise<any> {
    if (event.length > 4) {
      return new Promise((resolve) => {
        this._serviceRequestService.getFilterDataBasedOnSearchKeyWord(event, memberId).subscribe((response) => {
          resolve(response);
        });
      });
    }
    return Promise.resolve(null);
  }
}
